var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.blocks),function(block,index){return _c('v-' + block.acf_fc_layout,_vm._b({key:block.acf_fc_layout + ':' + index,tag:"component"},'component',block,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }